import templateUrl from './views/component.tpl.html';
import templateStatisticPieUrl from './views/statisticPieChart.tpl.html';
import templateStatisticBarUrl from './views/statisticBarChart.tpl.html';
import templateStatisticTabelUrl from './views/statisticTabel.tpl.html';
import templateStatisticNumberUrl from './views/statisticNuberChart.tpl.html';

import templateFullscreenStatisticPieUrl from './views/fullscreen-statistics/statisticPieChart.tpl.html';
import templateFullscreenStatisticBarUrl from './views/fullscreen-statistics/statisticBarChart.tpl.html';
import templateFullscreenStatisticTabelUrl from './views/fullscreen-statistics/statisticTabel.tpl.html';
import templateFullscreenStatisticNumberUrl from './views/fullscreen-statistics/statisticNuberChart.tpl.html';

import AlGuestlistDashboardController from './controllers/component';
import AlGuestlistStatisticController from './controllers/statistic';
import AlGuestlistDashboardNumberStatisticController from "./controllers/statisticNumber";

angular.module('festzelt-os.modules.guestlists')
    .component('alGuestlistDashboard', {
        bindings: {
            guestlist: '<'
        },
        controller: AlGuestlistDashboardController,
        controllerAs: 'vm',
        templateUrl
    });

angular.module('festzelt-os.modules.guestlists')
    .component('alGuestlistDashboardStatisticPieChart', {
        bindings: {
            statistic: '<',
            refresh: '<',
            maximize: '<',
            guestlist: '<'
        },
        controller: AlGuestlistStatisticController,
        controllerAs: 'vm',
        templateUrl:  templateStatisticPieUrl
    });

angular.module('festzelt-os.modules.guestlists')
    .component('alGuestlistDashboardStatisticBarChart', {
        bindings: {
            statistic: '<',
            refresh: '<',
            maximize: '<',
            guestlist: '<'
        },
        controller: AlGuestlistStatisticController,
        controllerAs: 'vm',
        templateUrl:  templateStatisticBarUrl
    });

angular.module('festzelt-os.modules.guestlists')
    .component('alGuestlistDashboardStatisticTabel', {
        bindings: {
            statistic: '<',
            refresh: '<',
            maximize: '<',
            guestlist: '<'
        },
        controller: AlGuestlistStatisticController,
        controllerAs: 'vm',
        templateUrl:  templateStatisticTabelUrl
    });

angular.module('festzelt-os.modules.guestlists')
    .component('alGuestlistDashboardStatisticNumber', {
        bindings: {
            statistic: '<',
            refresh: '<',
            maximize: '<',
            guestlist: '<'
        },
        controller: AlGuestlistDashboardNumberStatisticController,
        controllerAs: 'vm',
        templateUrl:  templateStatisticNumberUrl
    });

angular.module('festzelt-os.modules.guestlists')
    .component('alGuestlistDashboardFullscreenStatisticPieChart', {
        bindings: {
            statistic: '<',
            refresh: '<',
            maximize: '<',
            guestlist: '<'
        },
        controller: AlGuestlistStatisticController,
        controllerAs: 'vm',
        templateUrl:  templateFullscreenStatisticPieUrl
    });

angular.module('festzelt-os.modules.guestlists')
    .component('alGuestlistDashboardFullscreenStatisticBarChart', {
        bindings: {
            statistic: '<',
            refresh: '<',
            maximize: '<',
            guestlist: '<'
        },
        controller: AlGuestlistStatisticController,
        controllerAs: 'vm',
        templateUrl:  templateFullscreenStatisticBarUrl
    });

angular.module('festzelt-os.modules.guestlists')
    .component('alGuestlistDashboardFullscreenStatisticTabel', {
        bindings: {
            statistic: '<',
            refresh: '<',
            maximize: '<',
            guestlist: '<'
        },
        controller: AlGuestlistStatisticController,
        controllerAs: 'vm',
        templateUrl:  templateFullscreenStatisticTabelUrl
    });

angular.module('festzelt-os.modules.guestlists')
    .component('alGuestlistDashboardFullscreenStatisticNumber', {
        bindings: {
            statistic: '<',
            refresh: '<',
            maximize: '<',
            guestlist: '<'
        },
        controller: AlGuestlistDashboardNumberStatisticController,
        controllerAs: 'vm',
        templateUrl:  templateFullscreenStatisticNumberUrl
    });



// WEBPACK FOOTER //
// ./src/app/modules/guestlists/components/al-guestlist-dashboard/component.js